import { render, staticRenderFns } from "./DetailsReaderArray.vue?vue&type=template&id=2027fa34&"
import script from "./DetailsReaderArray.vue?vue&type=script&lang=js&"
export * from "./DetailsReaderArray.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReaderArray.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports